module.exports = {"name":"xterm.fit","main":"fit.js","private":true}


//////////////////
// WEBPACK FOOTER
// ./~/xterm/lib/addons/fit/package.json
// module id = 10
// module chunks = 0